import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { marked } from 'marked';
import './CustomPage.css';

function CustomPage({ slug }) {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/api/v1/pages/${slug}`);
        setPage(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching page:', err);
        setError('Page not found or unavailable');
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug]);

  if (loading) {
    return (
      <div className="custom-page loading">
        <div className="container">
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="custom-page error">
        <div className="container">
          <h2>Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="custom-page">
      <div className="container">
        <h1>{page.title}</h1>
        <div className="page-content" dangerouslySetInnerHTML={{ __html: marked(page.content) }} />
      </div>
    </div>
  );
}

export default CustomPage;
